
// npm install firebase --save

// https://www.youtube.com/watch?v=niPgyv53x8c

  // Your web app's Firebase configuration
  import firebase from 'firebase'
  
  const firebaseConfig = {
    apiKey: "AIzaSyD0I-HaukgDUnALq1uBXCGbAaSkVc4RAuk",
    authDomain: "golf-ee7a0.firebaseapp.com",
    databaseURL: "https://golf-ee7a0.firebaseio.com",
    projectId: "golf-ee7a0",
    storageBucket: "golf-ee7a0.appspot.com",
    messagingSenderId: "256948841030",
    appId: "1:256948841030:web:f9a31fac58f58305ab7847"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  export default {
      database: firebase.database()
  }